import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import helpers from '../helpers';

const { Stack, Heading, Paragraph, Box, TreeView } = designSystem;
const { extendItemsFieldsActions, populateFieldsTitles } = helpers;

function GeneralTab({ modalContentRef, fields, onEditField, onChangeFieldOrder, onDeleteField }) {
  return fields.length ? (
    <Box paddingBottom="spacing-3-xl">
      <TreeView
        items={extendItemsFieldsActions(populateFieldsTitles(fields), [onEditField, onDeleteField])}
        interaction="sortable"
        portalContainer={modalContentRef.current}
        onChange={onChangeFieldOrder}
      />
    </Box>
  ) : (
    <div className="ws-contact-form-settings-modal__empty-state">
      <Stack gap="spacing-4-xs">
        <Heading type="heading-5" appearance="medium-emphasis" align="center">
          {i18next.t('Add items to the form')}
        </Heading>
        <Paragraph appearance="medium-emphasis" align="center">
          {i18next.t('For your form to function, add at least one item.')}
        </Paragraph>
      </Stack>
    </div>
  );
}

GeneralTab.propTypes = {
  modalContentRef: PropTypes.shape().isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string,
      options: PropTypes.array,
      order: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      required: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onEditField: PropTypes.func.isRequired,
  onChangeFieldOrder: PropTypes.func.isRequired,
  onDeleteField: PropTypes.func.isRequired,
};

export default GeneralTab;
